// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2sBGl","content":"RecentSearches_content__10m8L"};